{
  "pt": {
    "todo": {
      "actions": {
        "add": "Adicionar tarefa",
        "cancel": "Cancelar",
        "delete_todo": "Eliminar tarefa",
        "edit": "Editar tarefa",
        "save": "Guardar"
      },
      "attributes": {
        "active": "Ativo",
        "assignee": "Responsável",
        "completed": "Concluído",
        "description": "Descrição",
        "due_date": "Data de vencimento",
        "title": "Título"
      },
      "labels": {
        "active": "ativo",
        "allDone": "Todas as tarefas estão concluídas!",
        "allTodos": "Todas as tarefas",
        "completed": "concluído",
        "filterTodos": "Filtrar tarefas",
        "filters": "Filtros",
        "myTodos": "As minhas tarefas",
        "myTodosCount": "As minhas tarefas ({count})",
        "noActiveTodos": "Não há todos activos",
        "noActiveTodosDashboard": "Parabéns, não tem tarefas em aberto!",
        "noCompletedYet": "Ainda não há tarefas concluídas.",
        "noTodosCustomer": "Ótimo! Não tem nenhuma tarefa em aberto.",
        "selectAProjectFirst": "Selecionar primeiro um projeto",
        "showLess": "Mostrar menos",
        "showOthers": "Mostrar outro | Mostrar outro {count}"
      },
      "toasts": {
        "create": "Tarefa criada",
        "delete": "Tarefa eliminada",
        "update": "Tarefa actualizada"
      },
      "validation": {
        "needtitle": "Título é obrigatório"
      }
    }
  }
}
